var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radiotogglewrap"},[_c('label',{staticClass:"lable"},[_vm._v(" Сделать по умолчанию ")]),_c('fieldset',{staticClass:"inputradiotoggle"},[[_c('label',{staticClass:"radiotoggle"},[_c('CheckBox',{attrs:{"text":"Шаблон по умолчанию","color-checked":"accentfill","color-un-checked":"gray"}})],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }